import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Popover
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const ButtonPopover = ({ classes, children, color, variant, title, buttonStyle, popoverStyle, disabled, size }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const togglePopover = (e) => {
    const el = anchorEl ? null : e.currentTarget;
    setAnchorEl(el); 
  }

  return (
    <>
      <Button
        className={classes.buttonWithIcon}
        size={size}
        variant={variant || 'contained'}
        color={color || 'primary'}
        style={{ color: 'white', ...buttonStyle }}
        onClick={togglePopover}
        disabled={disabled}
      >
        {title}
        <ArrowDropDownIcon className={classes.buttonRightIcon} />
      </Button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={togglePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className={classes.container} style={popoverStyle}>
          {children}
        </div>
      </Popover>
    </>
  );
}

const styles = theme => ({
  buttonWithIcon: {
    margin: theme.spacing(1)
  },
  buttonRightIcon: {
    marginLeft: 4,
    fontSize: 20,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
});

export default withStyles(styles)(ButtonPopover);
